import React, { useRef, useState } from "react";
import { AiFillDelete } from "react-icons/ai";
import expand from "../utils/expand.png";
import products from "../utils/products.png";

import { format } from "date-fns";

const TableGrouped = ({
  handleInputChange,
  groupedLeads,
  statusMapping, //
  setSelectedLeads,
  selectedLeads,
  handleViewLead, //
  calculateAgedDays, //
  openStatusModal, //
  onDeleteChecked, //
  editingRowId,
  setEditingRowId,
  leadsWithProducts
}) => {
  // const [editingRowId, setEditingRowId] = useState(null);
  const newRowRef = useRef();
  const statusOrder = [
    "newLead",
    "contacted",
    "attemptedToContact",
    "qualified",
    "unQualified",
  ];

  // Sort groupedLeads by statusOrder
  const sortedGroupedLeads = Object.keys(groupedLeads)
    .sort((a, b) => statusOrder.indexOf(a) - statusOrder.indexOf(b))
    .reduce((sorted, key) => {
      sorted[key] = groupedLeads[key];
      return sorted;
    }, {});

  const handleChange = (id, field, value) => {
    // Call the method passed from the parent
    handleInputChange(id, field, value);
  };

  const splitText = (stringReceived) => {

    console.log("stringReceived ", stringReceived)

    let n = 10; // insert a character after every 5 characters
    let insertChar = "\n";
    let outputString = stringReceived.split(",")

    return (outputString)

  }

  const arrangeSalesPersonNameArray = (arrayToBeOrdered) => {


    console.log("arrayToBeOrdered ", arrayToBeOrdered)

    let newArray = arrayToBeOrdered.map((textToBeEdited) => {

      if (textToBeEdited.includes("@")) {

        return "Email : " + textToBeEdited

      } else if (!isNaN(textToBeEdited.replace(/\s/g, ""))) {
        return "Mob : " + textToBeEdited
      } else {
        return textToBeEdited
      }

    })

    let mobObject = newArray.filter((itemFilter) => {
      return itemFilter.includes("Mob")
    })

    let emailObject = newArray.filter((itemFilter) => {
      return itemFilter.includes("@")
    })


    let nameObject = newArray.filter((itemFilter) => {
      return !itemFilter.includes("@") && !itemFilter.includes("Mob")
    })

    console.log("arrayToBeOrdered newArray mobObject", newArray, mobObject, emailObject)

    return [nameObject, mobObject, emailObject]


  }

  return (
    <div className="overflow-x-auto mt-0 ">
      {selectedLeads.length > 0 && (
        <div className="mb-2">
          <button
            onClick={onDeleteChecked}
            className="bg-red-500 text-white px-2 py-2 rounded mr-2"
            disabled={selectedLeads.length === 0}
          >
            <AiFillDelete size={18} />
          </button>
        </div>
      )}

      {Object.entries(sortedGroupedLeads).map(([status, leads]) => (
        <div key={status} className="mb-6">
          <h2 className="text-lg font-thin mb-2">
            {statusMapping[status] === "Attempted"
              ? "Attempted To Contact"
              : statusMapping[status] && statusMapping[status] === "New Lead"
                ? "New"
                : statusMapping[status] || status}{" "}
            Leads ({leads.length})
          </h2>
          <table className="table-auto w-full border-collapse border border-gray-200">
            <thead className="bg-gray-100">
              <tr>
                <th className="shadow-sm px-1 py-0.5 w-[20px] text-left">
                  <input
                    type="checkbox"
                    className="rounded border border-sm shadow"
                    onChange={(e) =>
                      setSelectedLeads(
                        e.target.checked ? leads.map((row) => row.lead_id) : []
                      )
                    }
                    checked={
                      selectedLeads.length > 0 &&
                      leads.every((row) => selectedLeads.includes(row.lead_id))
                    }
                  />
                </th>
                <th className="shadow-sm px-1 py-0.5  text-left font-normal w-[100px]">
                  Lead ID
                </th>
                <th className="shadow-sm px-1 py-0.5  text-left font-normal w-[200px]">
                  Date
                </th>
                <th className="shadow-sm px-1 py-0.5  text-left font-normal w-[300px]">
                  SalesPerson
                </th>
                <th className="shadow-sm px-1 py-0.5  text-left font-normal w-[300px]">
                  Organization/Customer
                </th>
                <th className="shadow-sm px-1 py-0.5 w-[150px] text-left font-normal">
                  Status
                </th>
                <th className="shadow-sm px-1 py-0.5 w-[200px] text-left font-normal">
                  Project
                </th>
                <th className="shadow-sm px-1 py-0.5 w-[200px] text-left font-normal">
                  Contact Person
                </th>
                <th className="shadow-sm px-1 py-0.5 w-[150px] text-left font-normal">
                  Title
                </th>
                <th className="shadow-sm px-1 py-0.5 w-[150px] text-left font-normal">
                  Email
                </th>
                <th className="shadow-sm px-1 py-0.5 w-[300px] text-left font-normal">
                  Phone
                </th>
                <th className="shadow-sm px-1 py-0.5 w-[200px] text-left font-normal">
                  Entry Location
                </th>
                <th className="shadow-sm px-1 py-0.5 w-[50px] text-left font-normal">
                  Probability
                </th>
              </tr>
            </thead>
            <tbody className="bg-white px-2">
              {leads.map((row) => (
                <tr
                  key={row.lead_id}
                  ref={row.lead_id === editingRowId ? newRowRef : null}
                  className={`${selectedLeads.includes(row.lead_id) ? "bg-blue-100" : ""
                    }`}
                >
                  <td className="shadow-sm px-1 py-0.5  text-left">
                    <div className="flex justify-between items-center w-auto">
                      <input
                        type="checkbox"
                        className="rounded border border-sm "
                        checked={selectedLeads.includes(row.lead_id)}
                        onChange={() =>
                          setSelectedLeads((prev) =>
                            prev.includes(row.lead_id)
                              ? prev.filter((id) => id !== row.lead_id)
                              : [...prev, row.lead_id]
                          )
                        }
                      />

                      {leadsWithProducts.has(row.lead_id) && (
                        // {row.leadIsItemAdded && ( 
                        <div className="w-1 h-1 bg-green-500 text-xs ml-1 p-1 rounded-lg"></div>
                        //  )}

                        // <img
                        //   src={products}
                        //   alt="products-icon"
                        //   className="w-4 h-4 bg-green-500 text-xs p-1 ml-0.5 rounded-lg"
                        // />
                      )}
                    </div>
                  </td>

                  <td className="shadow-sm px-1 py-0.5 w-[100px] ">
                    <div>
                      {row.lead_id}
                    </div>
                  </td>
                  <td className="shadow-sm px-1 py-0.5 w-[200px] ">
                    <div>
                      {
                        format(row.lead_entryTime, "dd-MM-yyyy")}
                    </div>
                  </td>

                  <td className="shadow-sm px-1 py-0.5 w-[300px] ">
                    <div>

                      {row.lead_salespersonName
                        ?
                        arrangeSalesPersonNameArray(splitText(row.lead_salespersonName
                        )) ?
                          arrangeSalesPersonNameArray(splitText(row.lead_salespersonName
                          ))[0]
                          : "--"
                        :
                        "--"
                      }
                    </div>
                  </td>


                  <td className="shadow-sm px-1 py-0.5 w-[300px] ">
                    <div className="flex items-center justify-between ">
                      <input
                        type="text"
                        // value={row.lead_primarycontact}
                        value={row.lead_organization}

                        onChange={(e) =>
                          handleChange(row.lead_id, "lead", e.target.value)
                        }
                        autoFocus={row.lead_id === editingRowId}
                        // className=" outline-none w-auto p-0 border-none text-sm bg-blue-200 "
                        className=" outline-none  p-0 border-none text-sm bg-transparent "
                      />

                      <div className="flex items-center  justify-center gap-2">
                        <img
                          onClick={() => handleViewLead(row)}
                          src={expand}
                          alt="expand-icon"
                          className="w-4 h-4 cursor-pointer"
                        />
                        <div className="text-[0.70rem] font-thin bg-gray-400 px-0.5 rounded-md text-white">
                          {calculateAgedDays(row.lead_entryTime)}
                        </div>
                      </div>
                    </div>
                  </td>

                  <td
                    className={`shadow-sm px-1 py-0.5  cursor-pointer`}
                    onClick={() => openStatusModal(row)}
                  >
                    {row.lead_status && (
                      <button
                        className={`w-full text-white text-center p-1 rounded ${row.lead_status === "newLead"
                          ? "bg-orange-400"
                          : row.lead_status === "contacted"
                            ? "bg-blue-600"
                            : row.lead_status === "attemptedToContact"
                              ? "bg-red-400"
                              : row.lead_status === "qualified"
                                ? "bg-green-400"
                                : row.lead_status === "unQualified"
                                  ? "bg-red-600"
                                  : "bg-gray-300"
                          }`}
                      >
                        {statusMapping[row.lead_status] || row.lead_status}{" "}
                      </button>
                    )}
                  </td>


                  <td className="shadow-sm px-1 py-0.5 ">
                    {row.lead_CampaignId}
                  </td>

                  <td className="shadow-sm px-1 py-0.5 ">
                    <input
                      type="text"
                      // value={row.lead_organization}
                      value={row.lead_primarycontact}

                      onChange={(e) =>
                        handleChange(
                          row.lead_id,
                          "organization",
                          e.target.value
                        )
                      }
                      // autoFocus={row.lead_id === editingRowId}
                      className=" outline-none  w-full p-0 border-none text-sm  bg-transparent"
                    />

                    {/* {row.organization} */}
                  </td>
                  <td className="shadow-sm px-1 py-0.5 ">
                    <input
                      type="text"
                      value={row.lead_primarycontacttitle}
                      onChange={(e) =>
                        handleChange(row.lead_id, "title", e.target.value)
                      }
                      // autoFocus={row.lead_id === editingRowId}
                      className=" outline-none  w-full p-0 border-none text-sm  bg-transparent"
                    />

                    {/* {row.title} */}
                  </td>
                  <td className="shadow-sm px-1 py-0.5 ">
                    <input
                      type="text"
                      value={row.lead_email}
                      onChange={(e) =>
                        handleChange(row.lead_id, "email", e.target.value)
                      }
                      // autoFocus={row.lead_id === editingRowId}
                      className=" outline-none  w-full p-0 border-none text-sm  bg-transparent"
                    />

                    {/* {row.email} */}
                  </td>
                  <td className="shadow-sm px-1 py-0.5 ">
                    <input
                      type="text"
                      value={row.lead_phone}
                      onChange={(e) =>
                        handleChange(row.lead_id, "phone", e.target.value)
                      }
                      // autoFocus={row.lead_id === editingRowId}
                      className=" outline-none  w-full p-0 border-none text-sm  bg-transparent"
                    />

                    {/* {row.phone} */}
                  </td>
                  <td className="shadow-sm px-1 py-0.5  ">
                    {/* <input
                      type="text"
                      value={row.lead_notes}
                      onChange={(e) =>
                        handleChange(row.lead_id, "notes", e.target.value)
                      }
                      // autoFocus={row.lead_id === editingRowId}
                      className=" outline-none  w-full p-0 border-none text-sm  bg-transparent text-ellipsis overflow-hidden whitespace-nowrap"
                    /> */}

                    {row.lead_assignedto?.length > 0 ? <a href={`http://maps.google.com/?q=${row.lead_assignedto}`}>View</a> : ""}
                  </td>
                  <td className="shadow-sm px-1 py-0.5 ">
                    <input
                      type="text"
                      value={row.lead_probability}
                      onChange={(e) =>
                        handleChange(row.lead_id, "probability", e.target.value)
                      }
                      // autoFocus={row.lead_id === editingRowId}
                      className=" outline-none  w-full p-0 border-none text-sm  bg-transparent text-ellipsis overflow-hidden whitespace-nowrap text-center"
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ))}
    </div>
  );
};

export default TableGrouped;
